import React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import arrow_right from "./../../assets/ic_header_arrow_right.svg";
import arrow_left from "./../../assets/ic_header_arrow_left.svg";
import { useState } from "react";
const ReactTableFixedColumns = withFixedColumns(ReactTable);
export default function EngagedDashboardGrid(props)
{
    const [columnPage,setcolumnPage] =useState(0);

    const generateColumns=(ServiceData)=>{
        if(!ServiceData.TableData)
        {
            return [];
        } 
        
        let ColumnName= ServiceData.TableData.map((x) => 
            {
                return {serviceName:x.ServiceName};
            });

            const columns = [];
            
            var columnStatus={
                Header: "Status",
                fixed: "left",
                columns: [
                    {
                        id: "Status_name",
                        Header: "Status",
                        headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','borderLeft':'solid 1px #ccc','borderRight':'solid 1px #ccc'},
                        accessor: "Status",
                        width: 200,					
                    },
                ]
            }
            
            let ServiceColumnsName= ColumnName.map((x) => 
            {
                /*columns.push(
                    {
                        id: x.serviceName,
                        headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                        Header: x.serviceName,
                        accessor: x.serviceName.replace(/ /g, '').replace(/\./g,''),
                        width: 200,
                        getProps: (state, rowInfo, column) => {
                            return {
                                style: {
                                    borderLeft: 'solid 1px #ccc',	
                                    borderRight:'solid 1px #ccc',				
                                },
                            };
                        }
                    }
                )*/

                return {
                    id: x.serviceName,
                    headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                    Header: x.serviceName,
                    accessor: x.serviceName.replace(/ /g, '').replace(/\./g,''),
                    width: 200,
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: {
                                borderLeft: 'solid 1px #ccc',	
                                borderRight:'solid 1px #ccc',				
                            },
                        };
                    },
                };
            });

            var dsd={
                Header: "Services",
                columns: ServiceColumnsName
            };
            columns.push(columnStatus);
            columns.push(dsd);
            return columns;
	}

    const generateNewDesignColumns=()=>{
        var columns= [];

        if(columnPage==0)
        {
            columns.push(
                // {
                //     id: "ServiceName",
                //     Header: "Service Name",
                //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','borderLeft':'solid 1px #ccc','borderRight':'solid 1px #ccc'},
                //     accessor: "ServiceName",
                //     width: 200,	
                //     style:{'whiteSpace': 'unset'},
                //     fixed:"left"				
                // },
                // {
                //     id: "Requested",
                //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                //     Header: "Requested",
                //     accessor: "Requested",
                //     //width: 150,
                //     getProps: (state, rowInfo, column) => {
                //         return {
                //             style: {
                //                 borderLeft: 'solid 1px #ccc',	
                //                 borderRight:'solid 1px #ccc',				
                //             },
                //         };
                //     },
                // },
                // {
                //     id: "Eligible",
                //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                //     Header: "Eligible",
                //     accessor: "Eligible",
                //     //width: 150,
                //     getProps: (state, rowInfo, column) => {
                //         return {
                //             style: {
                //                 borderLeft: 'solid 1px #ccc',	
                //                 borderRight:'solid 1px #ccc',				
                //             },
                //         };
                //     },
                // },
                // {
                //     id: "Quotation Sent",
                //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                //     Header: "Quotation Sent",
                //     accessor: "Quotation Sent",
                //     //width: 200,
                //     getProps: (state, rowInfo, column) => {
                //         return {
                //             style: {
                //                 borderLeft: 'solid 1px #ccc',	
                //                 borderRight:'solid 1px #ccc',				
                //             },
                //         };
                //     },
                // },
                // {
                //     id: "Prepared",
                //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                //     Header: "Prepared",
                //     accessor: "Prepared",
                //     //width: 200,
                //     getProps: (state, rowInfo, column) => {
                //         return {
                //             style: {
                //                 borderLeft: 'solid 1px #ccc',	
                //                 borderRight:'solid 1px #ccc',				
                //             },
                //         };
                //     },
                // },
                // {
                //     id: "Partial Payment Pending",
                //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                //     Header: "Partial Payment Pending",
                //     accessor: "Partial Payment Pending",
                //     //width: 200,
                //     getProps: (state, rowInfo, column) => {
                //         return {
                //             style: {
                //                 borderLeft: 'solid 1px #ccc',	
                //                 borderRight:'solid 1px #ccc',				
                //             },
                //         };
                //     },
                // },
                // {
                //     id: "Payment Received",
                //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                //     Header: "Payment Received",
                //     accessor: "Payment Received",
                //     //width: 200,
                //     getProps: (state, rowInfo, column) => {
                //         return {
                //             style: {
                //                 borderLeft: 'solid 1px #ccc',	
                //                 borderRight:'solid 1px #ccc',				
                //             },
                //         };
                //     },
                // },
                // {
                //     id: "Ready For Progression",
                //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                //     Header: "Ready For Progression",
                //     accessor: "Ready For Progression",
                //     //width: 200,
                //     getProps: (state, rowInfo, column) => {
                //         return {
                //             style: {
                //                 borderLeft: 'solid 1px #ccc',	
                //                 borderRight:'solid 1px #ccc',				
                //             },
                //         };
                //     },
                // },
                // {
                //     id: "Awaiting For Information/Documents",
                //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                //     Header: "Awaiting For Information/Documents",
                //     accessor: "Awaiting For Information/Documents",
                //     //width: 200,
                //     getProps: (state, rowInfo, column) => {
                //         return {
                //             style: {
                //                 borderLeft: 'solid 1px #ccc',	
                //                 borderRight:'solid 1px #ccc',				
                //             },
                //         };
                //     },
                // },
                // {
                //     id: "Payment Confirmed By Partner",
                //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                //     Header: 
                //     <div>Payment Confirmed By Partner
                //         <br></br>
                //         <img
                //             alt=""
                //             src={arrow_right}
                //             height={"20px"}
                //             width={"20px"}
                //             className="conv-mr10"
                //             onClick={()=>{
                //                 setcolumnPage(1);
                //             }}
                //         />
                //     </div>,
                //     accessor: "Payment Confirmed By Partner",
                //     //width: 200,
                //     getProps: (state, rowInfo, column) => {
                //         return {
                //             style: {
                //                 borderLeft: 'solid 1px #ccc',	
                //                 borderRight:'solid 1px #ccc',				
                //             },
                //         };
                //     },
                // },
            );
        }
        else
        {
            columns.push(
                // {
                //     id: "ServiceName",
                //     Header: "Service Name",
                //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','borderLeft':'solid 1px #ccc','borderRight':'solid 1px #ccc'},
                //     accessor: "ServiceName",
                //     width: 200,	
                //     style:{'whiteSpace': 'unset'},
                //     fixed:"left"				
                // },
                // {
                //     id: "Service Delivery Start",
                //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                //     Header: "Service Delivery Start",
                //     accessor: "Service Delivery Start",
                //     //width: 200,
                //     getProps: (state, rowInfo, column) => {
                //         return {
                //             style: {
                //                 borderLeft: 'solid 1px #ccc',	
                //                 borderRight:'solid 1px #ccc',				
                //             },
                //         };
                //     },
                // },
                // {
                //     id: "ServiceDeliverablesReady",
                //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                //     Header: "Service Deliverables Ready",
                //     accessor: "Service Deliverables ready",
                //     //width: 200,
                //     getProps: (state, rowInfo, column) => {
                //         return {
                //             style: {
                //                 borderLeft: 'solid 1px #ccc',	
                //                 borderRight:'solid 1px #ccc',				
                //             },
                //         };
                //     },
                // },
                // {
                //     id: "Full Payment Requested",
                //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                //     Header: "Full Payment Requested",
                //     accessor: "Full Payment Requested",
                //    //width: 200,
                //     getProps: (state, rowInfo, column) => {
                //         return {
                //             style: {
                //                 borderLeft: 'solid 1px #ccc',	
                //                 borderRight:'solid 1px #ccc',				
                //             },
                //         };
                //     },
                // },
                // {
                //     id: "Full Payment Received",
                //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                //     Header: "Full Payment Received",
                //     accessor: "Full Payment Received",
                //     //width: 200,
                //     getProps: (state, rowInfo, column) => {
                //         return {
                //             style: {
                //                 borderLeft: 'solid 1px #ccc',	
                //                 borderRight:'solid 1px #ccc',				
                //             },
                //         };
                //     },
                // },
                // {
                //     id: "Delivered",
                //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                //     Header: "Delivered",
                //     accessor: "Delivered",
                //     //width: 200,
                //     getProps: (state, rowInfo, column) => {
                //         return {
                //             style: {
                //                 borderLeft: 'solid 1px #ccc',	
                //                 borderRight:'solid 1px #ccc',				
                //             },
                //         };
                //     },
                // },
                // {
                //     id: "Cancelled",
                //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                //     Header: "Cancelled",
                //     accessor: "Cancelled",
                //     //width: 200,
                //     getProps: (state, rowInfo, column) => {
                //         return {
                //             style: {
                //                 borderLeft: 'solid 1px #ccc',	
                //                 borderRight:'solid 1px #ccc',				
                //             },
                //         };
                //     },
                // },
                // {
                //     id: "Services Signed up",
                //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                //     Header: "Services Signed up",
                //     accessor: "Services_Signed_up",
                //     //width: 200,
                //     getProps: (state, rowInfo, column) => {
                //         return {
                //             style: {
                //                 borderLeft: 'solid 1px #ccc',	
                //                 borderRight:'solid 1px #ccc',				
                //             },
                //         };
                //     },
                // },
                // {
                //     id: "% Signed up to Service Requested",
                //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                //     Header: "% Signed up to Service Requested",
                //     accessor: "Signed_up_to_service_requested",
                //     //width: 200,
                //     getProps: (state, rowInfo, column) => {
                //         return {
                //             style: {
                //                 borderLeft: 'solid 1px #ccc',	
                //                 borderRight:'solid 1px #ccc',				
                //             },
                //         };
                //     },
                // },
                // {
                //     id: "% Delivered to Signed Up",
                //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                //     Header: 
                //     <div>% Delivered to Signed Up
                //     <br></br>
                //     <img
                //         alt=""
                //         src={arrow_left}
                //         height={"20px"}
                //         width={"20px"}
                //         className="conv-mr10"
                //         onClick={()=>{
                //             setcolumnPage(0);
                //         }}
                //     />
                // </div>,
                //     accessor: "Delivered_to_Signed_Up",
                //     //width: 200,
                //     getProps: (state, rowInfo, column) => {
                //         return {
                //             style: {
                //                 borderLeft: 'solid 1px #ccc',	
                //                 borderRight:'solid 1px #ccc',				
                //             },
                //         };
                //     },
                // },
            );
        }
        return columns;
	}



    return (
        
		    <ReactTableFixedColumns
                data={props.data || []}
                columns={props.fromNewDesign?generateNewDesignColumns():generateColumns(props.ServiceData)}
                pageSize={props.data.length}
                sortable={false}
                showPagination={false}
                style={{overflowY: "auto",height: "445px"}}	
                className="-striped"
            />
	);
}